import useWidget from '../../../hooks/useWidget.js';
import useWidgetState from '../../../hooks/useWidgetState.js';
import { getFacetConfigType } from '../utils/index.js';
export const useSearchResultsSelectedFilters = () => {
    const { config } = useWidget();
    const { selectedFacets = [] } = useWidgetState();
    return selectedFacets.map((f) => {
        const type = getFacetConfigType(config, f.facetId);
        return {
            ...f,
            valueLabel: f.valueLabel || f?.facetValueText || '',
            type,
        };
    });
};
export default useSearchResultsSelectedFilters;
